const DOOR_TO_DOOR_PARTNERS = [
  {
    id: 'gryv',
    partnerName: 'Gryv Corp',
    partnerShortName: 'GC',
    leadSourceMatcher: ls => ls.includes('gryv') && !ls.includes('gryvpartners'),
    excludedProviderTechnicalNames: ['edf', 'plenitude'],
  },
  {
    id: 'brj',
    partnerName: 'BRJ',
    partnerShortName: 'BRJ',
    leadSourceMatcher: ls => ls.includes('brjenergie'),
    excludedProviderTechnicalNames: ['edf', 'plenitude'],
  },
]

export default DOOR_TO_DOOR_PARTNERS
